import React from 'react';
import { Table, Button } from 'semantic-ui-react';
import { useDeleteGR } from '~/groupings';
import Dayjs from 'dayjs';

const SpecialsTable = props => {


    const {
        growthRates,
        setInitialValues,
        setGRModalOpen,
        propertyId
    } = props;

    const { mutate: deleteGR } = useDeleteGR();

    return (
        <Table columns={3} fixed size='small'>
            <Table.Header>
                <Table.Row>
                    <Table.HeaderCell> Name </Table.HeaderCell>
                    <Table.HeaderCell> Growth Rate </Table.HeaderCell>
                    <Table.HeaderCell> Last Market Date Change </Table.HeaderCell>
                    <Table.HeaderCell textAlign='right'> Actions </Table.HeaderCell>
                </Table.Row>
            </Table.Header>
            <Table.Body>
                {growthRates.map((group, i) => (
                    <Table.Row key={`group-${i}`}>
                        <Table.Cell content={group.name} />
                        <Table.Cell content={group.growth_rate} />
                        <Table.Cell content={Dayjs(group.date).format('MM/DD/YYYY')} />
                        <Table.Cell textAlign='right'>
                            <Button.Group>
                                <Button
                                    compact
                                    content='Edit'
                                    icon='edit'
                                    onClick={() => {
                                        setInitialValues(group);
                                        setGRModalOpen(true);
                                    }}
                                />
                                <Button
                                    compact
                                    negative
                                    content='Delete'
                                    icon='delete'
                                    onClick={() => {
                                        deleteGR(group.id);
                                    }}
                                />
                            </Button.Group>
                        </Table.Cell>
                    </Table.Row>
                ))}
            </Table.Body>
            <Table.Footer>
                <Table.Row>
                    <Table.HeaderCell colSpan='4' textAlign='right'>
                        <Button
                            compact
                            primary
                            content='New Growth Rate'
                            onClick={() => {
                                setInitialValues({ property_id: propertyId });
                                setGRModalOpen(true);
                            }}/>
                    </Table.HeaderCell>
                </Table.Row>
            </Table.Footer>
        </Table>
    );
};

export default SpecialsTable;
